import * as React from 'react';

import PageBase from '../../components/layout/PageBase';
import AppCta from '../../components/utility/AppCta';

import styles from '../../styles/sass/pages/LandingPage.module.scss';

const AppLandingPage = () => (
  <PageBase>
    <div
      className={`page-container ${styles.landingPage} ${styles.appDownload}`}
    >
      <AppCta topper={false} />
    </div>
  </PageBase>
);

export default AppLandingPage;
